
import React from 'react';
import { connect } from "react-redux";
import { DEVICE_WIDTH } from '../../lib/constants';

/**
 * React wrapper around
 * {@link https://bulma.io/documentation/components/modal/}
 *
 */
class Overlay extends React.Component {

  render = () => {

    const divStyle = {
      backgroundColor: "rgba(10, 10, 10, 0.5)",
    };
    return (
      <div className={ "modal is-active" } >
        <div className="modal-background" style={divStyle} />
        { this.props.children }
      </div>
    )
  }
}

class ModalComponent extends React.Component {

  static showCount = 0;

  componentDidMount = () => {
    Modal.showCount += 1;
  };

  componentWillUnmount = () => {
    Modal.showCount -= 1;
  };

  createContainerStyle = () => {
      const orignalContainerStyle = {
          ...this.props.container_style
      }
      const responsiveContainerStyle = {}

      return this.props.app.width <= DEVICE_WIDTH.large ? responsiveContainerStyle : orignalContainerStyle;
  }

  render = () => {
    const dismissText = this.props.dismissText ? this.props.dismissText : "Cancel";
    const actionText = this.props.actionText;

    const container_style = this.createContainerStyle();
    
    const button_style = {
      justifyContent: "flex-end",
      marginRight: "1rem",
    };

    const footer_style = {
      backgroundColor: "rgb(245, 245, 245)",
      borderBottomRightRadius: "6px",
      borderBottomLeftRadius: "6px",
    };

    let footer = null;

    if (this.props.buttonList) {
      footer = !this.props.noFooter
        ? (
          <footer className="modal-card-foott" style={footer_style}>
            <div style={{float: "right", padding: "1rem", marginRight: "2rem"}}>
              { this.props.buttonList.map((button, index) => {
                return (
                  <button
                    className="button"
                    tabIndex={-1}
                    key={index}
                    onClick={button.cb}
                    style={button_style}
                    disabled={button.disable}>
                    { button.label }
                  </button>
                )
              })}
            </div>
          </footer>
        ) : null;
    } else {
      footer = !this.props.noFooter
        ? (
          <footer className="modal-card-foott" style={footer_style}>
            <div style={{float: "right", padding: "1rem", marginRight: "2rem"}}>
              { actionText && <button className="button is-info" onClick={this.props.onAction} style={button_style}>
                { actionText }
              </button> }
              <button className="button" onClick={this.props.onDismiss}>{ dismissText }</button>
            </div>
          </footer>
        ) : null;
    }


    return (
      <div className={ "modal is-active" }>
        <div className="modal-background"/>
        <div className="modal-card" style={container_style}>
          <header className="modal-card-head">
            <p className="modal-card-title">{this.props.title}</p>
            <button className="delete" aria-label="close" onClick={this.props.onClose}/>
          </header>
          <section className="modal-card-body">
            { this.props.children }
          </section>
          { footer }
        </div>
      </div>
    );
  }
}

class ModalComponent2 extends React.Component {

  static showCount = 0;

  componentDidMount = () => {
    Modal.showCount += 1;
  };

  componentWillUnmount = () => {
    Modal.showCount -= 1;
  };

  createContainerStyle = () => {
    const orignalContainerStyle = {
      ...this.props.container_style
    }
    const responsiveContainerStyle = {}

    return this.props.app.width <= DEVICE_WIDTH.large ? responsiveContainerStyle : orignalContainerStyle;
  }

  render = () => {
    const container_style = this.createContainerStyle();

    const button_style = {
      justifyContent: "flex-end",
      marginRight: "1rem",
      border: "solid black 1px",
    };

    const footer_style = {
      backgroundColor: "rgb(245, 245, 245)",
      borderBottomRightRadius: "6px",
      borderBottomLeftRadius: "6px",
    };

    const on_mouse_down = ev => ev.preventDefault();

    let footer = null;

    /**
     * button {
     *   cb: () => {}
     *   disable: bool
     *   label: Anything
     * }
     */
    footer = !this.props.noFooter
      ? (
        <footer className="modal-card-foott" style={footer_style}>
          <div style={{float: "right", padding: "1rem"}}>
            { this.props.buttonList.map((button, index) => {
              return (
                <button
                  className="button"
                  tabIndex={-1}
                  key={index}
                  onMouseDown={on_mouse_down}
                  onClick={button.cb}
                  style={button_style}
                  disabled={button.disable}>
                  { button.label }
                </button>
              )
            })}
          </div>
        </footer>
      ) : null;

    const overlay_style = {
      backgroundColor: "rgba(10, 10, 10, 0.5)",
    };

    return (
      <div className={ "modal is-active" }>
        <div className="modal-background" style={overlay_style}/>
        <div className="modal-card" style={container_style}>
          <header className="modal-card-head" style={this.props.header_style}>
            { this.props.header }
          </header>
          <section className="modal-card-body" style={this.props.body_style}>
            { this.props.children }
          </section>
          { footer }
        </div>
      </div>
    );
  }
}


const mapStateToProps = state => {
  return {
    app: state.app,
  }
}

const Modal = connect(mapStateToProps)(ModalComponent);
const Modal2 = connect(mapStateToProps)(ModalComponent2);

export { Overlay, Modal, Modal2 };
